export const siteInfo = {
  name: '国产在线一区',
  fullName: '国产在线一区·高清视频聚合平台',
  tagline: '汇聚海量高清国产视频，畅享流畅在线观影体验',
  description: '国产在线一区汇聚海量高清国产视频内容，提供流畅在线播放体验，无需下载即可观看，支持多设备访问，内容持续更新，是您观看国产精品视频的首选平台。',
  url: 'https://www.guochangzaixian.com',
  email: 'contact@guochangzaixian.com',
  phone: '400-888-9999',
  address: '北京市朝阳区建国路88号SOHO现代城A座15层',
  founded: '2018',
  brandStory: '国产在线一区成立于2018年，致力于打造中国领先的高清视频聚合平台。我们汇聚了来自全国各地的优质视频内容，涵盖电影、电视剧、综艺、纪录片、动漫等多个品类。平台采用先进的视频编码技术和CDN加速服务，确保用户无论身在何处都能享受流畅的高清观影体验。经过多年的发展，国产在线一区已累计服务超过5000万用户，日活跃用户突破300万，成为国产视频领域最具影响力的平台之一。',
  teamSize: '200+',
  usersCount: '5000万+',
  dailyActive: '300万+',
  videoCount: '10万+',
  honors: [
    '2024年度最佳视频聚合平台',
    '2023年中国互联网创新企业奖',
    '2022年度用户最喜爱视频平台',
    '2021年内容安全优秀示范单位',
    '2020年北京市高新技术企业',
  ],
};